import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import jobs from '../jobs';
import axios from "axios";

export default function QuoteInfoPage() {
    const { id } = useParams();
    const [info, setInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchQuoteInfo() {
            try {
                const res = await axios.get(`/api/manage/quotes/${id}`);
                setInfo(res.data);
            } catch (err) {
                console.error("견적 요청 정보를 불러오지 못했습니다.", err);
            }
        }
        fetchQuoteInfo();
        setLoading(false);
    }, [id]);

    if (loading) {
        return <div style={{ textAlign: "center", marginTop: 60 }}>로딩 중...</div>;
    }
    if (!info) {
        return <div style={{ textAlign: "center", marginTop: 60, color: "#ff4d4f" }}>견적 요청 정보를 불러올 수 없습니다.</div>;
    }

    return (
        <div style={{ maxWidth: 800, margin: "40px auto", fontFamily: "sans-serif" }}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>견적 요청 상세정보</h2>
            <table style={{ width: "100%", borderCollapse: "collapse", background: "#fafbfc", borderRadius: 8, overflow: "hidden", marginBottom: 32 }}>
                <tbody>
                    <tr>
                        <th style={thStyle}>ID</th>
                        <td style={tdStyle}>{id}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>User ID</th>
                        <td style={tdStyle}><a href={`/users/${info ? info.userId : '..'}`}>{info ? info.userId : '유저 ID'}</a></td>
                    </tr>
                    <tr>
                        <th style={thStyle}>작성자</th>
                        <td style={tdStyle}>{info ? info.name : '작성자'}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>이메일</th>
                        <td style={tdStyle}>{info ? info.email : '이메일'}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>지역</th>
                        <td style={tdStyle}>{info ? info.locale : '지역'}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>업무</th>
                        <td style={tdStyle}>
                            {(() => {
                                if (!info) return null;
                                const a = jobs.find(j => j.key === info.job);
                                return a ? a.label : info.job;
                            })()}
                        </td>
                    </tr>
                    <tr>
                        <th style={thStyle}>견적 요청 내용</th>
                        <td style={tdStyle}>{info ? info.quote : `test
                        test`}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>첨부파일</th>
                        <td style={tdStyle}>
                            {(info && info.files && info.files.length > 0)
                                ? info.files.map((file, idx) => (
                                    <a key={idx} href={`/api/manage/quotes/${id}/files/${idx}`} target="_blank" rel="noopener noreferrer" style={{ marginRight: 8 }}>
                                        {file}
                                    </a>
                                ))
                                : "없음"}
                        </td>
                    </tr>
                    <tr>
                        <th style={thStyle}>채택 여부</th>
                        <td style={tdStyle}>{(info && info.adoptedRequoteId) ? 'O' : 'X'}</td>
                    </tr>
                </tbody>
            </table>
            <h3 style={{ marginBottom: 16 }}>해당 요청에 제출된 견적서 리스트</h3>
            <table style={{ width: "100%", borderCollapse: "collapse", background: "#fff", borderRadius: 8 }}>
                <thead>
                    <tr style={{ background: "#f5f6fa" }}>
                        <th style={thStyle}>채택</th>
                        <th style={thStyle}>ID</th>
                        <th style={thStyle}>회사명</th>
                        <th style={thStyle}>평점</th>
                        <th style={thStyle}>제출일</th>
                        <th style={thStyle}>합산 가격</th>
                    </tr>
                </thead>
                <tbody>
                    {(info && info.requotes.length > 0) ? info.requotes.map((item, idx) => (
                        <tr key={idx} onClick={() => window.location.href = `/requote/${item.id}`} style={{ cursor: "pointer" }}>
                            <td style={tdStyle}>{(idx === info.adoptedRequoteId) ? '✅':''}</td>
                            <td style={tdStyle}>{item.id}</td>
                            <td style={tdStyle}>{item.member.companyName}</td>
                            <td style={tdStyle}>{item.member.rating}</td>
                            <td style={tdStyle}>{new Date(item.createdAt).toLocaleDateString()}</td>
                            <td style={tdStyle}>{item.sum.toLocaleString()}원</td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={4} style={{ textAlign: "center", color: "#888", padding: 24 }}>
                                제출된 견적서가 없습니다.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <center>
                <button
                    style={{
                        background: "#ff4d4f",
                        color: "#fff",
                        border: "none",
                        borderRadius: 8,
                        padding: "12px 40px",
                        fontWeight: 600,
                        fontSize: 16,
                        cursor: "pointer",
                        marginTop: 24
                    }}
                    onClick={() => {
                        if (window.confirm(`정말로 이 요청을 삭제하시겠습니까?`)) {
                            axios.delete(`/api/manage/quotes/${id}`)
                                .then(() => window.location.href = "/quote")
                                .catch(err => alert("삭제 실패: " + err.message));
                            alert("삭제되었습니다.");
                        }
                    }}
                >
                견적 요청 삭제
                </button>
            </center>
        </div>
    );
}

const thStyle = {
    background: "#f5f6fa",
    textAlign: "left",
    padding: "10px 8px",
    fontWeight: 600,
    borderBottom: "1px solid #e1e1e1"
};

const tdStyle = {
    padding: "10px 8px",
    borderBottom: "1px solid #f0f0f0",
    whiteSpace: "pre-wrap",
};